export default __webpack_public_path__ + "static/anr-btn-c139b5774d378f38bba08c9a93c9c3a2.png";